export default __webpack_public_path__ + "static/media/product-item-04.c082bce9.jpg";